import IgniteSlider from '@ignitesales/react-slider';
import React from 'react';
import {QuestionTypeViewPropTypes} from '../../../shapes/index.mjs';
import QuestionText from '../../questions/QuestionText.jsx';
import classNames from 'classnames';
import {getQuestionAnswersArray} from '../../../util/questionUtil.jsx';
import {getMessageValue} from '../../../i18n/messageUtil';
import { useIntl, FormattedMessage } from 'react-intl';
import MessageIfPresent from '../../MessageIfPresent';
import {useText} from '../../TextContext';

const Slider = props => {
  const {valueChanged, question, value: {value = []} = {}} = props;
  const textContext = useText();

  const {appkey} = question;

  const intl = useIntl();
  const cssBEM = 'slider';
  const selected = value?.length > 0 ? value[0] : value;

  const extended = false;
  const classes = {};
  classes[`${cssBEM}`] = true;
  classes[`${cssBEM}--non-extended`] = !extended;
  classes[`${cssBEM}--extended`] = extended;

  const selectedAnswerSubtext = (selected >= 0) && textContext?.[`${appkey}`]?.[`${selected}`]?.subtext || (
    <MessageIfPresent id={`${appkey}.${selected}.subtext`}>
      <span className="slider__subtext" >
        <FormattedMessage id={`${appkey}.${selected}.subtext`} />
      </span>
    </MessageIfPresent>
  );

  const answerOptions = (getQuestionAnswersArray(question) || []).map(answerOption => {
    return {
      ...answerOption,
      ariaLabel: getMessageValue(intl.locale, answerOption.key),
    };
  });

  return (
    <div className="question question--slider" id={appkey}>
      <QuestionText question={question} />
      <IgniteSlider
        name={appkey}
        onChange={valueChanged}
        selected={selected}
        className={classNames(classes)}
        answerOptions={answerOptions}
        extended={extended}
      />
      { selectedAnswerSubtext }
    </div>
  );
};

Slider.propTypes = QuestionTypeViewPropTypes;

export default Slider;
